/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { Card } from 'react-bootstrap';

const MyCard = (props) => {
    return (
        <Card style={{ margin: '12px', border: '1px solid #e2e8f0', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }} className="text-center">
            <Card.Header style={{ backgroundColor: '#f8fafc', fontWeight: '700', fontSize: '1.1rem', color: '#0f172a', borderBottom: '1px solid #e2e8f0', padding: '14px 18px' }}>
                {props.name}
            </Card.Header>
            <Card.Body style={{ backgroundColor: '#ffffff', padding: '20px' }}>
                <Card.Text style={{ color: '#64748b', fontSize: '0.9rem', marginBottom: '16px' }}>
                    {props.district ? props.district : 'District not provided'}
                </Card.Text>
                <a target='_blank' rel="noopener noreferrer" href={`coaching-details/${props.id}`} className="btn btn-primary btn-sm">
                    Show More
                </a>
            </Card.Body>
        </Card>
    );
};

export default MyCard;